// src/pages/LoginPage.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login }    = useAuth();
  const navigate     = useNavigate();
  const [form, setForm]   = useState({ email:'', password:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid email or password');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:24, background:'var(--bg-0)' }}>

      {/* Background grain */}
      <div style={{ position:'fixed', inset:0, backgroundImage:'radial-gradient(ellipse 80% 60% at 50% -10%, rgba(232,164,58,0.08) 0%, transparent 60%)', pointerEvents:'none' }}/>

      <div className="fade-up" style={{ width:'100%', maxWidth:400 }}>

        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ width:48, height:48, background:'var(--gold)', borderRadius:14, display:'inline-flex', alignItems:'center', justifyContent:'center', fontFamily:'var(--font-display)', fontWeight:700, fontSize:24, color:'#0c0d0f', marginBottom:16 }}>M</div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:'1.8rem', fontWeight:600, marginBottom:4 }}>
            MilleHills <span style={{ color:'var(--gold)' }}>Learning</span>
          </div>
          <div style={{ fontSize:'0.85rem', color:'var(--t-muted)' }}>Sign in to your learning account</div>
        </div>

        {/* Form */}
        <div className="card" style={{ padding:28 }}>
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div>
              <label style={{ display:'block', fontSize:'0.78rem', color:'var(--t-muted)', marginBottom:6, letterSpacing:'0.06em', textTransform:'uppercase' }}>Email</label>
              <input className="input" type="email" value={form.email} required autoFocus
                onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                placeholder="you@example.com"/>
            </div>
            <div>
              <label style={{ display:'block', fontSize:'0.78rem', color:'var(--t-muted)', marginBottom:6, letterSpacing:'0.06em', textTransform:'uppercase' }}>Password</label>
              <input className="input" type="password" value={form.password} required
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                placeholder="••••••••"/>
            </div>

            {error && (
              <div style={{ padding:'10px 14px', background:'rgba(240,96,96,0.1)', border:'1px solid rgba(240,96,96,0.25)', borderRadius:'var(--r-md)', fontSize:'0.84rem', color:'var(--red)' }}>
                {error}
              </div>
            )}

            <button type="submit" className="btn btn-primary" disabled={loading}
              style={{ marginTop:4, padding:'13px', fontSize:'0.95rem', fontWeight:600 }}>
              {loading ? 'Signing in…' : 'Sign In →'}
            </button>
          </form>
        </div>

        <div style={{ textAlign:'center', marginTop:24, fontSize:'0.82rem', color:'var(--t-muted)' }}>
          Use the same credentials as <a href={process.env.REACT_APP_SPA_URL || 'http://localhost:3000'} style={{ color:'var(--gold)' }}>millehills.rw</a>
        </div>
      </div>
    </div>
  );
}
